import { Button, Dialog } from "@uigovpe/components";
import type { PendingProductAction } from "../types";

type Props = {
  action: PendingProductAction | null;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function ProductActionDialog({
  action,
  isLoading,
  onCancel,
  onConfirm,
}: Props) {
  const title =
    action?.type === "delete"
      ? "Apagar produto"
      : action?.type === "publish"
        ? "Publicar produto"
        : "Ocultar produto";
  const verb =
    action?.type === "delete"
      ? "apagar"
      : action?.type === "publish"
        ? "publicar"
        : "ocultar";
  return (
    <Dialog
      visible={Boolean(action)}
      header={title}
      onHide={() => !isLoading && onCancel()}
      className="w-[min(92vw,460px)]!"
    >
      <div className="flex! flex-col! gap-5!">
        <p className="m-0! text-sm! leading-6! text-zinc-700!">
          Tem certeza que deseja {verb} o produto{" "}
          <strong>{action?.product.name}</strong>?
        </p>
        <div className="flex! flex-col-reverse! gap-3! sm:flex-row! sm:justify-end!">
          <Button
            type="button"
            label="Não"
            outlined
            disabled={isLoading}
            className="secondary-action-button"
            onClick={onCancel}
          />
          <Button
            type="button"
            className="text-white!"
            label={isLoading ? "" : "Sim, tenho certeza"}
            loading={isLoading}
            disabled={isLoading}
            onClick={onConfirm}
          />
        </div>
      </div>
    </Dialog>
  );
}
